import { Link, animateScroll as scroll } from "react-scroll";
import LandingsPage from "@/Layouts/LandingsPage";
import Contact from "@/Sections/Contact";
import Author from "@/Sections/Author";
import Learn from "@/Sections/Learn";
import Preview from "@/Sections/Preview";
import { Head } from "@inertiajs/inertia-react";

export default function Example() {
    return (
        <LandingsPage>
            <Head>
                <title>Succesvol afvallen zonder voedingsschema</title>
                <link
                    rel="canonical"
                    href={route("success-without-food-schema")}
                />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="In het boek ‘Succesvol afvallen zonder voedingsschema’ beschrijft Thierry van Melis van WE ARE welke stappen jij moet zetten om weer vol zekerheid door het leven te gaan."
                />
                <meta
                    property="og:description"
                    content="In het boek ‘Succesvol afvallen zonder voedingsschema’ beschrijft Thierry van Melis van WE ARE welke stappen jij moet zetten om weer vol zekerheid door het leven te gaan."
                />
                <meta
                    property="og:url"
                    content={route("success-without-food-schema")}
                />
                <meta property="og:type" content="website" />
                <meta
                    property="og:title"
                    content="Succesvol afvallen zonder voedingsschema - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/succesvol-afvallen-zonder-voedingsschema.png"
                />
            </Head>

            <div className="relative bg-black">
                {/* Hero */}
                <main className="lg:relative">
                    <div className="mx-auto max-w-7xl w-full pt-16 pb-20 text-center lg:py-48 lg:text-left">
                        <div className="px-4 lg:w-1/2 sm:px-8">
                            <h1 className="text-6xl tracking-tight font-extrabold italic uppercase font-custom text-white sm:text-6xl md:text-6xl lg:text-6xl xl:text-6xl">
                                <span className="text-we-are-yellow">
                                    Succesvol afvallen
                                </span>{" "}
                                <br />
                                <span className="text-we-are-purple text-5xl">
                                    zonder voedingsschema
                                </span>
                            </h1>

                            <p className="mt-3 max-w-md mx-auto text-lg text-gray-100 sm:text-xl md:mt-5 md:max-w-3xl">
                                Heb jij al verschillende voedingsschema’s
                                geprobeerd, maar blijft je succes uit? In
                                ‘Succesvol afvallen zonder voedingsschema’
                                beschrijft Thierry van Melis welke stappen jij
                                moet zetten om weer vol zekerheid door het leven
                                te gaan.
                            </p>
                            <ul className="list-none text-gray-100 mt-4 max-w-md mx-auto text-lg sm:text-xl md:mt-5 md:max-w-3xl">
                                <li className="ml-0 pl-0">
                                    Vanaf 1 januari beschikbaar in heel
                                    Nederland
                                </li>
                                <li className="ml-0 pl-0">
                                    128 pagina's met waardevolle informatie
                                </li>
                                <li className="ml-0 pl-0">
                                    ISBN: 978-94-93222-98-4
                                </li>
                                <li className="ml-0 pl-0">Druk: 1</li>
                                <li className="ml-0 pl-0">
                                    Bindwijze: paperback
                                </li>
                                <li className="ml-0 pl-0">
                                    Prijs: &euro; 19,95
                                </li>
                            </ul>
                            <div className="mt-10 sm:flex sm:justify-center lg:justify-start">
                                <div className="rounded-md shadow">
                                    <Link
                                        to="video"
                                        smooth={true}
                                        offset={0}
                                        duration={500}
                                        className="uppercase inline-flex items-center justify-center cursor-pointer px-6 py-3 border border-transparent text-base font-semibold rounded-md shadow-sm text-black bg-we-are-yellow focus:outline-none focus:ring-2 focus:ring-offset-2"
                                    >
                                        Meer informatie
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="relative w-full h-64 sm:h-72 md:h-96 lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2 lg:h-full">
                        <picture>
                            <source
                                srcSet="/assets/webp/succesvol-afvallen-zonder-voedingsschema.webp"
                                type="image/webp"
                                alt="Succesvol afvallen zonder voedingsschema"
                                className="absolute inset-0 w-full h-full object-contain"
                            />
                            <source
                                srcSet="/assets/succesvol-afvallen-zonder-voedingsschema.png"
                                type="image/jpeg"
                                alt="Succesvol afvallen zonder voedingsschema"
                                className="absolute inset-0 w-full h-full object-contain"
                            />
                            <img
                                src="/assets/succesvol-afvallen-zonder-voedingsschema.png"
                                alt="Succesvol afvallen zonder voedingsschema"
                                className="absolute inset-0 w-full h-full object-contain"
                            />
                        </picture>
                    </div>
                </main>
                {/* End Hero */}

                {/* Video */}
                <div className="relative" id="video">
                    <div className="mx-auto max-w-7xl pt-16 pb-20 text-center lg:py-48 lg:text-left">
                        <video className="w-auto h-full object-cover" controls>
                            <source
                                src="/assets/succesvol-afvallen-zonder-voedingsschema.mp4"
                                type="video/mp4"
                            />
                        </video>
                    </div>
                </div>
                {/* End Video */}

                <Learn />

                <Author />

                {/* Transformations */}
                <ul
                    role="list"
                    className="grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 md:grid-cols-4 lg:grid-cols-3 xl:grid-cols-4 xl:gap-x-8"
                >
                    {[...Array(12)].map((x, i) => (
                        <li className="relative ml-0 p-2 lg:px-4" key={i}>
                            <div
                                className={
                                    "group block w-full aspect-w-10 aspect-h-10 rounded-lg "
                                }
                            >
                                <picture>
                                    <source
                                        srcSet={`/assets/transformations/webp/personal-training-uden-schijndel-${
                                            1 + i
                                        }.webp`}
                                        width="960"
                                        height="960"
                                        type="image/webp"
                                        alt={"Transformatie " + (1 + i)}
                                        className="object-cover pointer-events-none"
                                    />
                                    <source
                                        srcSet={`/assets/transformations/personal-training-uden-schijndel-${
                                            1 + i
                                        }.jpg`}
                                        width="960"
                                        height="960"
                                        type="image/jpeg"
                                        alt={"Transformatie " + (1 + i)}
                                        className="object-cover pointer-events-none"
                                    />
                                    <img
                                        src={`/assets/transformations/personal-training-uden-schijndel-${
                                            1 + i
                                        }.jpg`}
                                        width="960"
                                        height="960"
                                        alt={"Transformatie " + (1 + i)}
                                        className="object-cover pointer-events-none"
                                    />
                                </picture>
                            </div>
                        </li>
                    ))}
                </ul>
                {/* End transformations */}

                <Preview />

                <Contact />
            </div>
        </LandingsPage>
    );
}
